/**
 * @generated SignedSource<<ac4aabcb2bde9eaf65d4e508aa433274>>
 * @relayHash e57a61bd41f5479e6556490d2ea7d14e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c7b0e3122dec1298ceb76433ce5fbd3e4430a478ea7d4b6fb261c805d14a348a

import type { ConcreteRequest } from 'relay-runtime';
export type ProjectSettingsSpacePoliciesQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type ProjectSettingsSpacePoliciesQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly policyAssociations: {
        readonly nodes: ReadonlyArray<{
          readonly policy: {
            readonly id: string;
            readonly rules: {
              readonly nodes: ReadonlyArray<{
                readonly id: string;
                readonly ruleType: {
                  readonly description: string | null;
                  readonly name: string | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type ProjectSettingsSpacePoliciesQuery = {
  response: ProjectSettingsSpacePoliciesQuery$data;
  variables: ProjectSettingsSpacePoliciesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "description"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectSettingsSpacePoliciesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraProjectPolicyAssociationConnection",
                "kind": "LinkedField",
                "name": "policyAssociations",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectPolicyAssociation",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectPolicy",
                        "kind": "LinkedField",
                        "name": "policy",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "args": (v2/*: any*/),
                            "concreteType": "JiraProjectPolicyRuleConnection",
                            "kind": "LinkedField",
                            "name": "rules",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraProjectPolicyRule",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "concreteType": "JiraProjectPolicyRuleType",
                                    "kind": "LinkedField",
                                    "name": "ruleType",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "rules(first:50)"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "policyAssociations(first:50)"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectSettingsSpacePoliciesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraProjectPolicyAssociationConnection",
                "kind": "LinkedField",
                "name": "policyAssociations",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectPolicyAssociation",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectPolicy",
                        "kind": "LinkedField",
                        "name": "policy",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "args": (v2/*: any*/),
                            "concreteType": "JiraProjectPolicyRuleConnection",
                            "kind": "LinkedField",
                            "name": "rules",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraProjectPolicyRule",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "concreteType": "JiraProjectPolicyRuleType",
                                    "kind": "LinkedField",
                                    "name": "ruleType",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v3/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "rules(first:50)"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "policyAssociations(first:50)"
              },
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c7b0e3122dec1298ceb76433ce5fbd3e4430a478ea7d4b6fb261c805d14a348a",
    "metadata": {},
    "name": "ProjectSettingsSpacePoliciesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7d8a8a5051e63049bcbc199547b4a855";

export default node;
